import http from "../../services/http"
import { setLoading, setNotLoading } from "../loading/loading.actions"
import { filterActionTypes } from "./filter.types"

export const setFilters = (filters) => {
  return {
    type: filterActionTypes.SET_FILTERS,
    payload: filters
  }
}

export const setSelectedFilter = (filter) => {
  return {
    type: filterActionTypes.SET_SELECTED_FILTER,
    payload: filter
  }
}

export const fetchFilters = () => {
  return async (dispatch) => {
    try {
      const response = await http.get("/filters")
      dispatch(setFilters(response.data))
    } catch (error) {
      console.error(error)
    }
  }
}

export const addFilter = (filter) => {
  return async (dispatch) => {
    try {
      const response = await http.post("/filters", filter)
      await dispatch(fetchFilters())
      return response.data
    } catch (error) {
      console.error('Erro ao criar filtro:', error.response?.data || error.message)
      throw error
    }
  }
}

export const updateFilter = (filter) => {
  return async (dispatch) => {
    try {
      const response = await http.put(`/filters/${filter.id}`, filter)
      dispatch(setSelectedFilter(response.data))
      await dispatch(fetchFilters())
      return response.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export const deleteFilter = (filter) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading())
      await http.delete(`/filters/${filter.id}`)
      dispatch(fetchFilters())
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(setNotLoading())
    }
  }
}